/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmailHtmlTemplateParams } from '../models/EmailHtmlTemplateParams';
import type { EmailRequest } from '../models/EmailRequest';
import type { GetEmailByTemplateModel } from '../models/GetEmailByTemplateModel';
import type { SendEmailByTemplateModel } from '../models/SendEmailByTemplateModel';
import type { SimpleEmailSendModel } from '../models/SimpleEmailSendModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmailingService {

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postGetEmailByTemplate(
requestBody?: GetEmailByTemplateModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/GetEmailByTemplate',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSendEmailByTemplate(
requestBody?: SendEmailByTemplateModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SendEmailByTemplate',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSendEmail(
requestBody?: SimpleEmailSendModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SendEmail',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSendEmailLegacy(
requestBody?: EmailRequest,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SendEmailLegacy',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postSendEmailByIdLegacy(
formData?: {
emailId?: number;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SendEmailByIdLegacy',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param uid 
   * @returns any Success
   * @throws ApiError
   */
  public static getEmailingView(
uid?: string,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/EmailingView',
      query: {
        'uid': uid,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSendNotificationEmail(
requestBody?: SimpleEmailSendModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SendNotificationEmail',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postSendHrPortalEmail(
requestBody?: SimpleEmailSendModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SendHrPortalEmail',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param departmentId 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postEmailingEmailTemplates(
departmentId: number,
requestBody?: EmailHtmlTemplateParams,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Emailing/email-templates/{departmentId}',
      path: {
        'departmentId': departmentId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

}
